import {
  getApiV1WeddingsByWeddingIdDisplayActivitiesWall,
  postApiV1WeddingsByWeddingIdActivitiesRandomNumberDraw,
  putApiV1WeddingsByWeddingIdAdminActivitiesWall,
} from '@wedding-tech/api-client'

import type { WallState } from './types'

export * from './types'

export async function drawRandomNumber(weddingId: string) {
  const response = await postApiV1WeddingsByWeddingIdActivitiesRandomNumberDraw(
    {
      path: { weddingId },
    },
  )

  if (!response.data?.success) {
    throw new Error('Failed to draw random number')
  }

  return response.data
}

export async function getWallState(weddingId: string) {
  const response = await getApiV1WeddingsByWeddingIdDisplayActivitiesWall({
    path: { weddingId },
  })
  if (!response.data?.success || !response.data?.data) {
    throw new Error('Failed to get wall state')
  }
  return response.data.data as WallState
}

export async function updateWallState(
  weddingId: string,
  updates: Partial<WallState>,
) {
  const response = await putApiV1WeddingsByWeddingIdAdminActivitiesWall({
    path: { weddingId },
    body: updates,
  })
  if (!response.data?.success) {
    throw new Error('Failed to update wall state')
  }
}

export async function resetWallState(weddingId: string) {
  const response = await putApiV1WeddingsByWeddingIdAdminActivitiesWall({
    path: { weddingId },
    body: {},
  })
  if (!response.data?.success) {
    throw new Error('Failed to reset wall state')
  }
}
